import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import { ClerkProvider } from '@clerk/react'

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY
const prefersDark = typeof window !== 'undefined'
  && window.matchMedia('(prefers-color-scheme: dark)').matches

if (process.env.REACT_APP_NODE_ENV === "production") {
  console.log = () => { };
}
if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Publishable Key')
}
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <>
      <ClerkProvider
        publishableKey={PUBLISHABLE_KEY}
        afterSignOutUrl="/login"
        appearance={{
          options: {
            logoImageUrl: prefersDark ? '/logo-dark.svg' : '/logo-light.svg',
            logoLinkUrl: '/',
          },
        }}
      >

        <BrowserRouter>
          <App />
        </BrowserRouter>

      </ClerkProvider>
    </>
  </React.StrictMode>,
)
//  start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
